import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useParams, useNavigate } from 'react-router-dom';
import { globalErrorHandler } from '../../../utils/GlobalErrorHandler';

const DrugScreeningFile = () => {
    const { guest_id } = useParams();
    const navigate = useNavigate();
    const [guestFiles, setGuestFiles] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const [filter, setFilter] = useState({ year: '', month: '' });
    const monthList = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    useEffect(() => {
        const now = new Date();
        setFilter({
            year: now.getFullYear(),
            month: now.getMonth()+1
        });
    }, []);

    useEffect(() => {
        if (guest_id && filter.year && filter.month) {
            fetchUploads();
        }
    }, [guest_id, filter.year, filter.month]);

    const fetchUploads = async () => {
        try {
            const res = await axios.get(`${process.env.REACT_APP_WEB_SERVICES_URL}/overseer/get-drug-screening`, {
                params: {
                    guest_id,
                    year: filter.year,
                    month: filter.month,
                },
                withCredentials: true,
            });
            if (res.data.status) {
                setGuestFiles(res.data.data); // [{ week: 1, filename }, ...]
            } else {
                setGuestFiles([]);
            }
        } catch (error) {
            globalErrorHandler(error, navigate);
        } finally {
            setIsLoading(false);
        }
    };

    const handleFilterChange = (e) => {
        const { name, value } = e.target;
        setFilter((prev) => ({ ...prev, [name]: value }));
    };



    const clearFilter = () => {
        const now = new Date();
        setFilter({
            year: now.getFullYear(),
            month: now.getMonth()+1
        });
    };

    return (
        <div className="container-fluid mt-4">
            <h3 className="mb-4">Guest Drug Screening Results</h3>

            <div className="card">
                <div className="card-body table-responsive">
                    <div className="row g-3 mb-3">
                        <div className="col-md-2">
                            <label className="form-label">Year</label>
                            <select className="form-select" name="year" value={filter.year} onChange={handleFilterChange}>
                                {Array.from({ length: 30 }, (_, i) => {
                                    const year = 2025 + i;
                                    return <option key={year} value={year}>{year}</option>;
                                })}
                            </select>
                        </div>

                        <div className="col-md-2">
                            <label className="form-label">Month</label>
                            <select className="form-select" name="month" value={filter.month} onChange={handleFilterChange}>
                                {monthList.map((m, i) => (
                                    <option key={i} value={i+1}>{m}</option>
                                ))}
                            </select>
                        </div>

                        <div className="col-md-2">
                            <label className="form-label">&nbsp;</label>
                            <button type="button" className="btn btn-dark w-100 rounded-3" onClick={clearFilter}>Clear</button>
                        </div>
                    </div>

                    <table className="table table-bordered">
                        <thead className="table-success">
                            <tr>
                                <th>Guest ID</th>
                                <th>Name</th>
                                <th>Contact Info</th>
                                <th>Week 1</th>
                                <th>Week 2</th>
                                <th>Week 3</th>
                                <th>Week 4</th>
                                <th>Week 5</th>
                            </tr>
                        </thead>

                        <tbody>
                            {isLoading ? (
                                <tr><td colSpan="11">Loading...</td></tr>
                            ) : guestFiles.length === 0 ? (
                                <tr><td colSpan="11">No data found.</td></tr>
                            ) : (
                                <>
                                    {guestFiles.map((guest) => (
                                        <tr key={guest.id}>
                                            <td>{`BBM${String(guest.id).padStart(4, '0')}`}</td>
                                            <td>{guest.name}</td>
                                            <td>{`${guest.phone ? guest.phone + ' ' : ''}${guest.email}`}</td>
                                            {[1, 2, 3, 4, 5].map((week) => {
                                                const file = guest[`week${week}_file`];
                                                return (
                                                    <td key={week}>
                                                        {file ? (
                                                            <a
                                                                href={`${process.env.REACT_APP_WEB_SERVICES_URL}/overseer/download-drug-screening/${file}`}
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                                className="btn btn-sm btn-success"
                                                            >
                                                                View
                                                            </a>
                                                        ) : (
                                                            <span className="text-muted">No File</span>
                                                        )}
                                                    </td>
                                                );
                                            })}
                                        </tr>
                                    ))}
                                </>
                            )}
                        </tbody>

                    </table>
                </div>
            </div>
        </div>
    );
};

export default DrugScreeningFile;
